// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { SmileOutlined };
